import { ArrowRightOutlined, SearchOutlined } from '@ant-design/icons';
import { Row, Col, Button, Input, ConfigProvider } from 'antd';
import { useContext } from 'react';
import { useState } from 'react';

const App = ({
    label_language = {
        children: {
            placeholder_search: {
                'zh-tw': "搜尋館藏書籍",
                en: "",
            }
        },
    },
    search = () => {

    },
    refResult
}) => {
    const [keyword, setKeyowrd] = useState("")
    // const language = useContext(ConfigProvider.ConfigContext).locale.locale
    // console.log(label_language)
    return (<>
        <Input
            onChange={(e) => setKeyowrd(e.target.value)}
            style={{ borderRadius: '20px', padding: '5px' }}
            placeholder={
                '   搜尋館藏書籍'
                // label_language.children.placeholder_search[language]
            }
            prefix={<SearchOutlined style={{ fontSize: '2rem', color: '#0000004d', paddingLeft: '10px' }} />}
            suffix={
                <Button
                    type='primary'
                    style={{ height: '42px', borderRadius: '20px', letterSpacing: '1px' }}
                    onClick={() => {
                        search(keyword)
                        if (refResult.current) {
                            console.log(refResult.current)
                            refResult.current?.click()
                        }
                    }}
                >
                    <text>找書去</text>
                    <ArrowRightOutlined style={{ fontSize: '1.2rem', }} />
                </Button>
            }
        />
    </>)
}
export default App;